import { apiHolder, configKeyStore, inWindow, util } from 'api';
const inElectron = apiHolder.api.getSystemApi().isElectron;
const storeApi = apiHolder.api.getDataStoreApi();
const scheduleTabOpenInWindow = configKeyStore['scheduleTabOpenInWindow'];
const systemApi = apiHolder.api.getSystemApi();
const dataStoreApi = apiHolder.api.getDataStoreApi();
const webLayoutPages = ['#message', '#app', '#schedule', '#disk', '#contact', '#setting'];
export const navigateToSchedule = (frameNavCallback) => {
    const keyHolder = storeApi.getSync(scheduleTabOpenInWindow.keyStr);
    if (inElectron() && keyHolder && keyHolder.suc && keyHolder.data && keyHolder.data === 'true') {
        systemApi.createWindow('schedule');
        return true;
    }
    return frameNavCallback && frameNavCallback();
};
export const isShowWebLayout = () => {
    var _a;
    const hash = (inWindow() && ((_a = decodeURIComponent(window.location.hash)) === null || _a === void 0 ? void 0 : _a.split('?')[0])) || '';
    return !systemApi.isElectron() && !systemApi.inEdm() && webLayoutPages.indexOf(hash) !== -1;
};
export function sortByOrder(tabs, order) {
    const mapIndex = {};
    order.forEach((key, index) => {
        mapIndex[key] = index;
    });
    let copy = [...tabs].sort((a, b) => {
        const i = mapIndex[a.name];
        const j = mapIndex[b.name];
        if (i === undefined && j === undefined) {
            return 0;
        }
        if (i !== undefined && j === undefined) {
            return -1;
        }
        if (i === undefined && j !== undefined) {
            return 1;
        }
        return i - j;
    });
    if (process.env.BUILD_ISEDM) {
        copy = copy.filter(tab => !['schedule', 'disk', 'contact', 'apps', 'enterpriseSetting'].includes(tab.name));
    }
    return copy;
}
export const TAB_STORAGE_KEY = 'SIDEBAR_ORDER';
export const TAB_DEFAULT_ORDER = [
    'mailbox',
    'aiStaff',
    'aiTeam',
    'wa',
    'wmData',
    'edm',
    'unitable-crm',
    'worktable',
    'enterpriseSetting',
    'site',
    'schedule',
    'contact',
    'message',
    'disk',
];
export function getTabsFromLocal() {
    try {
        const { data } = dataStoreApi.getSync(TAB_STORAGE_KEY);
        if (data) {
            return JSON.parse(data);
        }
        return [];
    }
    catch (e) {
        console.error('getTabsFromLocal', e);
        return [];
    }
}
export function saveTabsToLocal(data) {
    dataStoreApi.put(TAB_STORAGE_KEY, JSON.stringify(data), {
        noneUserRelated: false,
    });
}
export function getDefaultOrderFromLocal(tabs) {
    const tabsFromLocal = getTabsFromLocal();
    const order = tabsFromLocal.length > 0 ? tabsFromLocal : TAB_DEFAULT_ORDER;
    return sortByOrder(tabs, Array.isArray(order) ? order : TAB_DEFAULT_ORDER);
}
export const TAB_STR_SEP = '#@#';
export const recordDragList = (list, startIndex, endIndex) => {
    const result = [...list];
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
export const getKeyBoardList = () => {
    const command = util.getCommonTxt(' ');
    const separator = '';
    const base = [
        {
            id: 'setting',
            name: '设置',
            key: command + separator + '0',
            show: inElectron(),
        },
        {
            id: 'mailbox',
            name: '邮箱',
            key: command + separator + '1',
            show: true,
        },
        {
            id: 'message',
            name: '消息',
            key: command + separator + '2',
            show: inElectron(),
        },
        {
            id: 'schedule',
            name: '日历',
            key: command + separator + '3',
            show: inElectron(),
        },
        {
            id: 'disk',
            name: '云文档',
            key: command + separator + '4',
            show: inElectron(),
        },
        {
            id: 'contact',
            name: '通讯录',
            key: command + separator + '5',
            show: inElectron(),
        },
    ];
    if (process.env.BUILD_ISEDM) {
        const extra = [
            {
                id: 'edm',
                name: '营销',
                key: command + separator + '6',
                show: inElectron(),
            },
            {
                id: 'customer',
                name: '客户',
                key: command + separator + '7',
                show: inElectron(),
            },
        ];
        base.push(...extra);
    }
    return base;
};
